import {LicenseMgtListActions, LicenseMgtListActionTypes} from '../actions/license-mgt-list.actions';
import {LicenseMgtList} from '../license-mgt.model';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';


export interface State extends EntityState<LicenseMgtList> {
  Loaded: boolean;
  Loading: boolean;
  data: any[];
}

export function sortByLastActiveDate(a: LicenseMgtList, b: LicenseMgtList) {
  return a.LastActiveTime - b.LastActiveTime;
}

export const adapter: EntityAdapter<LicenseMgtList> = createEntityAdapter<LicenseMgtList>({
  selectId: info => info.InfoId
});

export const initialState: State = adapter.getInitialState( {
  Loaded: false,
  Loading: false,
  data: []
});


export function reducer(state = initialState, action: LicenseMgtListActions): State {
  switch (action.type) {
    case LicenseMgtListActionTypes.GetLicenseMgtLists:
      return {...state, Loaded: false, Loading: true};

    case LicenseMgtListActionTypes.LoadLicenseMgtLists:
      return adapter.setAll(action.payload, {...state, Loaded: true, Loading: false});

    case LicenseMgtListActionTypes.UpsertLicenseMgtLists: {
      // return adapter.upsertMany(action.payload, {...state, Loaded: true, Loading: false});
      return {...state, Loaded: true, Loading: false, data: action.payload};
    }

    case LicenseMgtListActionTypes.GetDeleteLicenseMgtLists:
      return {...state, Loaded: false, Loading: true};

    case LicenseMgtListActionTypes.DeleteLicenseMgtLists: {
      return adapter.removeOne(action.payload.id, {...state, Loaded: true, Loading: false});
    }

    case LicenseMgtListActionTypes.GetLicenseMgtListsFails: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
